import React from 'react';
import './Footer.css';
import { FaFacebookF, FaInstagram, FaTwitter } from 'react-icons/fa';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-brand">
          <h3>Gowri Prasanna<br />Convention Hall</h3>
          <p>Creating memorable events with elegance and sophistication since 2010.</p>
          <div className="footer-social">
            <a href="#" aria-label="Facebook"><FaFacebookF /></a>
            <a href="#" aria-label="Instagram"><FaInstagram /></a>
            <a href="#" aria-label="Twitter"><FaTwitter /></a>
          </div>
        </div>

        <div className="footer-column">
          <h4>Quick Links</h4>
          <ul>
            <li><a href="#home">Home</a></li>
            <li><a href="#about">About</a></li>
            <li><a href="#services-section">Services</a></li>
            <li><a href="#gallery">Gallery</a></li>
            <li><a href="#contact">Contact</a></li>
          </ul>
        </div>

        <div className="footer-column">
          <h4>Services</h4>
          <ul>
            <li><a href="#services-section">Corporate Events</a></li>
            <li><a href="#services-section">Wedding Ceremonies</a></li>
            <li><a href="#services-section">Birthday Parties</a></li>
            <li><a href="#services-section">Social Gatherings</a></li>
          </ul>
        </div>

        <div className="footer-column">
          <h4>Contact Info</h4>
          <p className="footer-contact-text">
            Stadium Road Kuvempunagar,<br />
            Venkatesh Rao Colony,<br />
            Tumakuru, Karnataka 572103
          </p>
        </div>
      </div>

      <div className="footer-bottom">
        <p>&copy; {new Date().getFullYear()} Gowri Prasanna Convention Hall. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
